import { AxiosResponse } from "axios";

import request from "../libs/request";

import { BuildingId } from "../types/building";
import { DateRange } from "../types/common";

import { Pageable, PageableRequest } from "./talkServices";

const baseUrl = "history";

export type HistoryRequest = PageableRequest & {
  type?: string;
};

export type HistorySummary = {
  spaceReservation: number;
  request: number;
  rent: number;
  incommodity: number;
};

export type HistoryItem = DateRange &
  BuildingId & {
    type: string;
    serviceId: string;
    createdAt: string;
    status: string;
    statusName: string;
    location: string;
    description: string;
    actualUserName: string;
    midCategoryName: string;
    lowerCategoryName: string;
    buildingName: string;
    buildingFloorId: string;
    floorName: string;
    usedDepartment: string;
  };

export type HistoryResponse = {
  pageable: Pageable;
  summaryForService: HistorySummary;
  data: HistoryItem[];
};

export const getHistory = (
  params: HistoryRequest
): Promise<AxiosResponse<HistoryResponse>> => {
  return request.get<HistoryResponse>(`${baseUrl}/${params.type}`, {
    params,
  });
};

export const getHistoryReservationConcurrent = (params: PageableRequest) => {
  return request.get<HistoryResponse>(`${baseUrl}/reservation/concurrent`, {
    params,
  });
};
